/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Admin_Commission_Confirm_BodyInputs */



/**
* | output |
* | --- |
* | "{count} entries, net {amount}." |
*
* @param {Partner_Admin_Commission_Confirm_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_commission_confirm_body = /** @type {((inputs: Partner_Admin_Commission_Confirm_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Commission_Confirm_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Einträge, netto ${i?.amount}.`)
	return /** @type {LocalizedString} */ (`${i?.count} entries, net ${i?.amount}.`)
});